<template>
  <div class="pano-container">
    <pano v-if="finalXml" class="full-container" :xml="finalXml"></pano>
    <div v-if="errorVisible" class="full-container error-outer">
      <div class="error-box">
        <h2 class="title">{{ title || errorTitle || "杯具啊！" }}</h2>
        <p>该酒店全景正在拍摄中，敬请期待~</p>
      </div>
    </div>
    <div class="pano-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import qs from "@halobear/utils/qs";
import { xml as getXml } from "@/api/pano";

import Pano from "./pano";

const isDev = process.env.NODE_ENV !== "production";

export default {
  components: {
    Pano,
  },
  props: {
    xml: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      errorVisible: false,
      errorTitle: this.title,
    };
  },
  computed: {
    finalXml() {
      if (isDev) return "static/test.xml";
      if (this.xml) return this.xml;
      const query = this.$route.query.hotel_id
        ? this.$route.query
        : qs.parse((window.location.search.split("?")[1] || "").split("#")[0]);
      let {
        hotel_id = 0,
        hall_id = 0,
        is_old,
        app = "",
        pano_id = "",
        phone = "",
      } = query;
      if (isDev && !hotel_id && !hall_id) {
        hotel_id = 1420;
        hall_id = 6567;
      }
      const loading = phone ? "halobear-loading" : "licheng-loading";
      return Number(hotel_id)
        ? getXml({ hotel_id, hall_id, is_old, app, pano_id, loading })
        : "";
    },
  },
};
</script>

<style lang="less" scoped>
.pano-container {
  background-color: #3d3d3d;
  min-height: 100vh;
}
#pano {
  &:deep(*) {
    box-sizing: content-box;
  }
}
.full-container {
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 10;
}
.error-outer {
  z-index: 10000;
  background-color: #f3f3f3;
  display: flex;
  justify-content: center;
  align-items: center;
  .error-box {
    margin: 0 auto;
    padding: 40px;
    background-color: #fff;
    width: 540px;
    z-index: 100000;
  }
  .title {
    color: #555;
    font-size: 2em;
    padding-bottom: 20px;
    line-height: 1.3;
  }
  .desc {
    color: #888;
    font-size: 14px;
  }
}
.pano-content {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 100;
}
</style>
